import React, { Component } from 'react';

import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'

import MySubmission from './MySubmission';
import MCSubmission from './MCSubmission';
import FCSubmission from './FCSubmission';
import TQSubmission from './TQSubmission';

class SubmissionParent extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      open: false,
      data:{
        'isSelectedCertification': false,
        'selectedCertificationId': '',
        'certificationType': '',
        'mcCertTopicId': '',
        'fullCertId': '',
        'topicName':'',
        'tqCertDetailId': ''
      },

    };

  }

  componentDidMount () {
        
  }

  onClickUpload = (certificationId, type, fullCertId, mcCertTopicId, topicName, tqCertDetailId) =>{
      let data = Object.assign({}, this.state.data)
      data.isSelectedCertification = true
      data.certificationType=type
      data.mcCertTopicId=mcCertTopicId
      data.fullCertId=fullCertId
      data.topicName=topicName
      data.tqCertDetailId = tqCertDetailId
      this.setState({data: data})
  }


  onBackToMain = () => {
    let data = Object.assign({}, this.state.data)
    data.isSelectedCertification = false
    this.setState({data: data}) 
  }

  render() {
    
    let ComponentToShow

    if(!this.state.data.isSelectedCertification){
      ComponentToShow = <MySubmission  clickUpload={this.onClickUpload}/>
    }
    else{
      if(this.state.data.certificationType === 'MC'){
        ComponentToShow = <MCSubmission mcCertTopicId={this.state.data.mcCertTopicId} topicName={this.state.data.topicName} handleBackToMain={this.onBackToMain}/>
      }
      else if(this.state.data.certificationType === 'FC'){
        ComponentToShow = <FCSubmission fullCertId={this.state.data.fullCertId} handleBackToMain={this.onBackToMain}/>
      }
      else if(this.state.data.certificationType === 'TQ'){
        ComponentToShow = <TQSubmission tqCertDetailId={this.state.data.tqCertDetailId} handleBackToMain={this.onBackToMain}/>
      }
    }

    return (
      <Grid>
        <GridCell span="12">
          
            {ComponentToShow}

        </GridCell>
      </Grid>  
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionParent);



// WEBPACK FOOTER //
// ./src/views/submissions/SubmissionParent.jsx